import useReviewsToggleStore from '~/modules/reviews/stores/useReviewsToggleStore';
import { passStoreThroughComposableFactory } from '~/utils/passStoreThroughComposableFactory';

const useReviewsToggle = () => passStoreThroughComposableFactory(useReviewsToggleStore());

export default useReviewsToggle;
